export default function createArrayFromNodeList(nodeList) {
    return [].slice.call(nodeList);
}
